import { render, staticRenderFns } from "./exchange-account.component.vue?vue&type=template&id=7bcf1da9"
import script from "./exchange-account.component.vue?vue&type=script&lang=js"
export * from "./exchange-account.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports